'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/supports-color/browser.js
// module id = 538
// module chunks = 0